export const FormControlTestAttributes = {
    errorText: 'form-control-error-text',
};
